import { MediumLargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import { Input } from "@nubeteck/components";
import { Card, Form, Skeleton } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import React, { useEffect } from "react";
import { getImportDataPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../StrapiError";

function StudentsImport({ isLoading, getData, data }: any) {
  const [pageNumber, setPageNumber] = React.useState(1);
  const [rowsCount, setRowsCount] = React.useState(5);
  const [studentName, setStudentName] = React.useState("");
  const { locale } = useLocale();
  const [importDataPage, setImportDataPage] = React.useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = React.useState<boolean>(true);
  const [hasError, setHasError] = React.useState(false);

  useEffect(() => {
    getData({ rowsCount, page: pageNumber, nombre: studentName });
  }, [studentName, rowsCount, pageNumber, getData]);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setImportDataPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    
    getImportDataPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setImportDataPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setImportDataPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  const columns = React.useMemo<ColumnsType<any>>(
    () => [
      {
        title: importDataPage?.student_import_table ?.[0]?.label || "No. identificación",
        dataIndex: "cedula",
      },
      {
        title: importDataPage?.student_import_table?.[1]?.label || "Nombres",
        dataIndex: "nombres",
      },
      {
        title: importDataPage?.student_import_table?.[2]?.label || "Apellidos",
        dataIndex: "apellidos",
      },
      {
        title: importDataPage?.student_import_table?.[3]?.label || "Correo electrónico",
        dataIndex: "correoElectronico",
      },
      {
        title: importDataPage?.student_import_table?.[4]?.label || "No. teléfono",
        dataIndex: "telefono",
      },
    ],
    [importDataPage],
  );

  if (hasError && locale === 'en') {
    return <StrapiError 
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setImportDataPage(null);
      }}
    />;
  }

  return (
    <>
      {isLoadingContent ? (
        <>
          <Skeleton.Input active size="large" style={{ width: 250, marginBottom: 16 }} />
          <Skeleton.Input active size="default" style={{ width: 300, marginBottom: 16 }} />
          <Card bodyStyle={{ padding: 0, width: "100%" }}>
            <Skeleton active paragraph={{ rows: 6 }} />
          </Card>
        </>
      ) : (
        <>
          <MediumLargeHeadingStyled>{importDataPage?.student_import.title || "Estudiantes importados"}</MediumLargeHeadingStyled>
          <Form.Item label={importDataPage?.student_import.search_input || "Búsqueda por nombre"}>
            <Input
              type="text"
              onChange={(e) => setStudentName(e.target.value)}
              placeholder={importDataPage?.student_import.search_input || "Búsqueda por nombre de estudiante"}
            />
          </Form.Item>
          <Card bodyStyle={{ padding: 0, width: "100%" }}>
            <Table<any>
              loading={isLoading}
              columns={columns}
              dataSource={data?.data?.result}
              rowKey={(v) => v.cedula}
              pagination={{
                onChange(page, pageSize) {
                  setPageNumber(page);
                  setRowsCount(pageSize);
                },
                pageSize: rowsCount,
                current: pageNumber,
                total: data?.data?.pageCount * rowsCount,
                showSizeChanger: true,
                style: { marginRight: "30px" },
              }}
              scroll={{ x: 800 }}
            />
          </Card>
        </>
      )}
    </>
  );
}

export default StudentsImport;
